export const state = () => ({
  newEventIsLoading: false, // yeni ürün loadingi
  eventListRequested: false, // daha önce ürün verisi çekilmiş mi?
  eventsAreLoading: true, // ürünler listesi loadingi
  events: [], // ürünler listesi
  count: 0, // kaç adet ürün bulunuyor bilgisi.
  page: 1, // sayfa bilgisi
  selectedEvent: null,
})
export const getters = {
  getEvents: (state) =>
    state.events
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.eventItemId === value.eventItemId)
      )
      .filter((e) => e.page === state.page),
  getEventsCount: (state) => state.count,
  getEventsLoading: (state) => state.eventsAreLoading,
  getSelectedEvent: (state) => state.selectedEvent,
  getEventById: (state) => (eventItemId) => {
    if (
      state.selectedEvent &&
      String(state.selectedEvent.eventItemId) === String(eventItemId)
    ) {
      return state.selectedEvent
    }
    return (
      state.events.find(
        (e) => String(e.eventItemId) === String(eventItemId)
      ) || null
    )
  },
}
export const mutations = {
  SET_PAGE(state, payload) {
    state.page = payload
  },
  SET_SELECTED_EVENT(state, payload) {
    state.selectedEvent = payload
  },
  SET_CLEAR_IT(state) {
    state.events = []
    state.newEventIsLoading = false
    state.eventListRequested = false
    state.eventsAreLoading = true
    state.count = 0
    state.selectedEvent = null
  },
  // ürünlerin loadingi
  SET_EVENTS_ARE_LOADING(state, payload) {
    state.eventsAreLoading = payload
  },
  // ürünleri projeye ekle
  SET_EVENTS(state, payload) {
    if (!state.eventListRequested) state.events = []
    if (payload.search !== '' || payload.categoryId !== -1) {
      state.events = []
      state.eventListRequested = false
    } else state.eventListRequested = true
    state.events = [...state.events, ...payload.data]
    state.count = payload.count
  },
}
export const actions = {
  // ürünleri getir
  async GET_EVENTS(
    { state, commit },
    { page = 1, search = '', limit = 12, categoryId = -1, currency }
  ) {
    commit('SET_PAGE', page)
    // cash tutulması istenmedi. aşağıdaki if bloğu cash bloğunu çalıştırır.
    // if (
    //   state.events.length !== 0 &&
    //   (search === '') & state.eventListRequested &&
    //   state.events.map((event) => event.page).includes(page) &&
    //   categoryId === -1
    // )
    //   return state.events.filter((e) => e.page === state.page) // daha önce liste çekilmişse return at.
    commit('SET_EVENTS_ARE_LOADING', true)
    const response = await this.$api.get(
      `UserEvents?page=${page}&searchKey=${search}&currency=${currency}&limit=${limit}${
        categoryId === -1 ? '' : `&categoryId=${categoryId}`
      }`
    )
    if (response.message === 'OK') {
      commit('SET_EVENTS', {
        count: response.data.count || 0,
        search,
        categoryId,
        data: response.data.items.map((d) => {
          // .items gelecek.
          return {
            ...d,
            page,
            type: 3,
          }
        }),
      })
      commit('SET_EVENTS_ARE_LOADING', false)
      return response.data
    } else
      commit('SET_EVENTS', {
        count: response.data.count || 0,
        search,
        categoryId,
        data: [],
      })
    commit('SET_EVENTS_ARE_LOADING', false)
    return []
  },
  async FIND_EVENT({ getters, commit }, { eventItemId, currency }) {
    const existing = getters.getEventById(eventItemId)
    if (existing) {
      commit('SET_SELECTED_EVENT', existing)
      return existing
    }
    const response = await this.$api.get(
      `UserEvents?page=1&searchKey=&currency=${currency}&limit=100`
    )
    if (response.message !== 'OK') return null
    const found = (response.data.items || []).find(
      (e) => String(e.eventItemId) === String(eventItemId)
    )
    if (found) {
      const item = { ...found, type: 3 }
      commit('SET_SELECTED_EVENT', item)
      return item
    }
    return null
  },
}
